const styles = (theme) => {
  return {
    container: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "center",
      "align-items": "center",
      height: "100%",
      width: "100%",
    },
    loader: {
      "justify-content": "center",
      "align-items": "center",
    },
    search: { width: "50%", marginBottom: 20, minWidth: 300 },
  };
};

export default styles;
